<template>
    <div class="h-100" style="padding-bottom: 14px;">
        <div style="border-bottom: 1px solid #1e1e1e;padding:8px 0px;padding-inline-start: 8px;display: flex;width: 100% !important;" class="w-100">
              <div class="asset-archive-wrapper">
                    <div class="mime-type-filter common-slot-class">
                        <div style="display: flex;border: 1px solid #4a4a4a !important; border-radius: .25rem !important; align-items: flex-start; width: 100%;">
                            <div v-if="Array.isArray(selectedMimeTypeValue) && selectedMimeTypeValue.length" class="filter-label apply-dull-text-color" style="width: 40%; flex-basis: 39%; margin-inline-start: 3px;margin-top: 5px;">{{$t('Mime Type')}} : </div>
                            <div style="flex:1">
                                <Multiselect
                                        v-model="selectedMimeTypeValue" 
                                        :options="mimeTypeList"
                                        ref="mimeTypeField"
                                        :multiple="true"
                                        track-by="id"
                                        :placeholder="$t('Select Mime type')"
                                        :close-on-select="true"
                                        :show-no-results="false"
                                        deselectLabel=""
                                        selectLabel=""
                                        selectedLabel=""
                                        :hideSelected="false"
                                        :showNoOptions="false"
                                        @remove="removeSelectedMimeTypeFilterFromTag($event)"
                                        @select="selectMimeTypeFilter($event,selectedMimeTypeValue)">
                                            <span slot="noResult">{{$t('No results')}}</span>
                                            <span slot="noOptions" style="display:none"></span>
                                            <div slot="tag" slot-scope="option" class="selected-tags-style">
                                            <div class="tags-display-style">{{$t(option.option.name)}}</div>
                                                <div class="remove-tag" v-on:click.stop.prevent="removeSelectedMimeTypeFilterFromTag(option.option)">
                                                    <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                            <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeMimeTypeFilterCheckboxAction(scope.option)" @focus.prevent :key="scope.option.value"/>
                                            <span style="margin-inline-start:12px;">{{ $t(scope.option.name) }}</span>
                                        </div>
                                </Multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="common-slot-class catalogs">
                         <div class="catalog-dropdown-wrapper" :style="catalogSelectedDropDown ? 'width:89%':'width:100%;'">
                             <CatalogMultiselectDropdownVue  :style="!catalogSelectedDropDown ? 'margin-inline-end: 8px;':''" :enableCatBrowser="true" @updatedCatalogsList="handleCatalogSelection" @removedCatalogFromList="handleCatalogRemove"  :allowSingleSelect="true" ref="catalogdropdownRef"></CatalogMultiselectDropdownVue>
                         </div>
                         <div class="remove-catalog-value" v-if="catalogSelectedDropDown">
                            <svg width="2em" height="1.5em" @click.stop="removeSelectedCatalog" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="remove-field-styles bi bi-x" style="height: 30px; width: 25px; color: rgb(169, 169, 169);"><path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path></svg>
                         </div>
                    </div>
                    <div class="comm-div calendar-wrapper">
                        <!-- <label class="config-label" :style="['deleted permanently','marked for delete','assets'].includes(filterReportContext)?'width:100px':'width:45px'">Created on</label> -->
                        <Datepicker
                            range
                            @focus="showUserFilter=false"
                            v-model="time1"
                            valueType="format"
                            :placeholder="$t('Select Created Date range')"
                            @change="handleCreatedDateChange()"
                            class="bg-transparent rounded  text-light date-range-picker-input"
                            style="height:42px !important" 
                            :title="time1"
                            :disabledDate="disabledDate"
                        ></Datepicker>
                    </div>
                    <div class="slug-name-main-wrapper">
                        <div class="search-bar-comm-style comm-div searchbar-wrapper" style="height: 38px; padding: 0px !important;  display: inline-block;width:100%;">
                            <div style="position:relative">
                                <input
                                type="text"
                                v-model="fileNameFilter"
                                class="bg-transparent rounded text-light w-100"
                                :placeholder="$t('Enter Slug name')+'...'"
                                @focus="showUserFilter = false"
                                @keyup.enter="updateFilenameSearchKey"
                                style="float:inline-start;padding-inline-end: 22px;"
                                />
                                <cancel-icon class="close-icon-searchbar" v-if="fileNameFilter.length > 0" @click="fileNameFilter = '',updateFilenameSearchKey()" style="position:absolute;inset-inline-end:1px;top:9px"></cancel-icon>
                            </div>
                        </div>
                    </div>
              </div>
            <div class="actions-button-wrapper">
                <div class="primary-btn-style justify-content-end"  style="padding: 0px !important;display:inline-block;margin: 0px !important;float:inline-start;text-align: start;">
                    <button  @click="searchArchivedAssetReport()" title="Search" class="btn btn-outline-secondary" style="width: 45px; margin: 0px 0px 0px 9px !important; padding: 6px;height:42px !important;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
                    </button>
                </div>
                <div>
                    <button-top-bar
                        class="download-button"
                        v-on:click.native="downloadArchiveReportData()">
                    </button-top-bar> 
                </div>
            </div>

        </div>
        <div class="archive-report-div">
            <table v-if="isDataLoaded && archiveReportData && Array.isArray(archiveReportData) && archiveReportData.length" class="table table-with-border table-scroll small-first-col"  style="background: transparent;width:100%;">
                <thead style="color: #eee">
                    <tr>
                        <th style="width: 70%;padding-inline-start: 0px !important;" class="text-left">{{$t('Slug Name')}}</th>
                        <th style="width: 18%" class="text-center">{{$t('Created Date')}}</th>
                        <!-- <th style="width: 6%;padding-inline-start: 0px !important;" class="text-left">{{$t('Containers')}}</th> -->
                        <!-- <th style="width: 10%;" class="text-center">{{$t('All Locations')}}</th> -->
                        <!-- <th style="width: 14%;" class="text-center">{{$t('Bin ID')}}</th> -->
                        <th style="width: 12%;" class="text-center">{{$t('Size')}}</th>
                    </tr>
                </thead>
                <tbody v-if="archiveReportData">
                    <tr
                        v-for="archiveLog in archiveReportData"
                        :key="archiveLog._id"
                        class="ccomm-logs-row" :class="{activeclass: activeIndex === archiveLog._id}">
    
                        <td class="text-left" style="position:relative;padding-inline-end: 10px !important;">
                            <div class="slug-name-wrapper">
                                <span v-if="Object.keys(archiveLog).includes('slug_name') && archiveLog.slug_name && archiveLog.slug_name.length > 0" class="text-ellipsis" :title="archiveLog.slug_name">{{ archiveLog.slug_name }}</span>
                                <span v-else class="validationmessage">-</span>
                                <div v-if="archiveLog.catalog_path && archiveLog.catalog_path.length" class="d-flex mb-1" style="position: relative;display:flex;font-size:12px;flex-wrap:wrap;">
                                    <div v-for="(path,index) in archiveLog.catalog_path" :key="path.id" class="dull-the-text comm-lengthy-value-styles">/{{modifyTextFormat(path.value)}}{{index == archiveLog.catalog_path.length -1?'':','}}&nbsp;&nbsp;</div>
                                </div>
                            </div>
                            <div class="locations" v-if="archiveLog && Array.isArray(archiveLog.all_locations) && archiveLog.all_locations.length">
                                 <span class="slug-common-label dull-the-text">{{$t('Locations')}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                 <div style="flex:1;">
                                   <span v-for="item in archiveLog.all_locations" :key="item" class="change-the-text-color mr-1">{{item}}</span>
                                 </div>
                            </div>

                            <div class="containers" v-if="archiveLog && Array.isArray(archiveLog.all_containers) && archiveLog.all_containers.length">
                                 <span class="slug-common-label dull-the-text">{{$t('Containers')}}&nbsp;&nbsp;</span>
                                 <div style="flex:1;">
                                   <span style="white-space: pre-wrap; margin-bottom: 2px; color: rgb(70, 197, 245); border-color: rgb(70, 181, 245);" v-for="item in archiveLog.all_containers" :key="item" class="change-the-text-color mr-1">{{item}}</span>
                                 </div>
                            </div>

                        </td>

                        <td class="text-center">
                            <!-- <span v-if="Object.keys(archiveLog).includes('created_datetime') && archiveLog.created_datetime && archiveLog.created_datetime.length > 0">{{formatedDate(archiveLog.created_datetime)}}</span> -->
                            <span v-if="Object.keys(archiveLog).includes('created_datetime') && archiveLog.created_datetime && archiveLog.created_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(archiveLog.created_datetime)">{{checkIsTodayoryesterdayDate(archiveLog.created_datetime)?getDateAndTimeInConfiguredFormat(archiveLog.created_datetime, true) : getDateAndTimeInConfiguredFormat(archiveLog.created_datetime)}}</span>
                            <span v-else class="validationmessage">-</span>
                        </td>

                        <!-- <td class="text-left" style="position:relative;">
                            <span v-if="Object.keys(archiveLog).includes('all_containers') && archiveLog.all_containers && archiveLog.all_containers.length > 0" class="text-ellipsis" :title="getUserNameFromId(archiveLog.user_id)">{{ archiveLog.all_containers.join(" ,") }}</span>
                            <span v-else class="validationmessage">-</span>
                        </td> -->

                        <!-- <td class="text-center">
                            <span v-if="Object.keys(archiveLog).includes('all_locations')  && archiveLog.all_locations && archiveLog.all_locations != null && archiveLog.all_locations != undefined"><span v-for="item in archiveLog.all_locations" :key="item" class="change-the-text-color mr-1 mb-1">{{item}}</span></span>
                            <span v-else class="validationmessage">-</span>
                        </td> -->

                        <!-- <td class="text-center">
                            <span v-if="Object.keys(archiveLog).includes('bin_id') && archiveLog.bin_id">{{archiveLog.bin_id}}</span>
                            <span v-else> - </span>
                        </td> -->

                        <td class="text-center">
                            <span v-if="Object.keys(archiveLog).includes('size') && archiveLog.size">{{getConvertedFileSize(archiveLog.size)}}</span>
                            <span v-else class="validationmessage">-</span>
                        </td>

                    </tr>
                </tbody>
            </table> 
            <div v-if="isDataLoaded && archiveReportData && Array.isArray(archiveReportData) && !archiveReportData.length" class="dull-the-text" style="display: flex;justify-content: center;align-items: center;font-size: 20px;height:100%;transform: translateY(-30%);">
                    {{$t('No Data Found')}}
            </div> 
           <div v-if="!isDataLoaded && archiveReportData && Array.isArray(archiveReportData) && !archiveReportData.length" class="dull-the-text" style="display: flex;justify-content: center;align-items: center;font-size: 20px;height:100%;transform: translateY(-30%);">
                    {{$t('Loading')}}...
            </div> 
        </div>  
        <div>
            <pagination
                v-model="page"
                :records="totalArchiveFiles"
                :per-page="perPage"
                @paginate="paginate"
                :options="options"
                style="margin-top:10px"
            />    
        </div>         
    </div>
</template> 

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import Utils from "../../components.utils.js";  
    import buttonsTopbar from "./headerbar.vue";
    import Pagination from "vue-pagination-2";
    import DatePicker from "vue2-datepicker";
    // import "vue2-datepicker/index.css";
    // import Multiselect from 'vue-multiselect';
    // import FiltersTopbar from "./filtersBar.vue";
    import Multiselect from 'vue-multiselect';
    import CatalogMultiselectDropdownVue from '../categories/CatalogMultiselectDropdown.vue';
    import cancelIcon from "../core/InlineCancelField.vue";
    export default {
        data(){
            return{
                page: 1,
                totalPages: -1,
                totalArchiveFiles: -1,
                perPage: -1,
                archiveReportData:[],
                archiveUserMap:[],
                userNameIdMap:{},
                time1:null,
                selectedUserInfo:{},
                selectedUserGroupInfo:{},
                filterBy:{},
                userListFromAutocomplete:[],
                userGroupListFromAutocomplete:[],
                searchByUser:"",
                showUserFilter:false,
                showUserGroupFilter:false,
                searchByGroup:"",
                fileNameFilter:"",
                completeFormData:{},
                isDataLoaded: false,
                // filterByAction:{
                //     state:"All",
                //     job_name:"All"
                // },
                options:{chunk:5},
                selectedJobName:"All",
                searchKey :"",

                payloadParams : {},
                activeIndex:null,

                selectedMimeTypeValue:[],
                mimeTypeList:[{name:'Video',id:1},{name:'Audio',id:2},{name:'Image',id:3},{name:'Text',id:4},{name:'Others',id:5}],
                catalogSelectedDropDown: null,
            } 
        },  
        components:{
            // 'k-progress': KProgress,
            pagination: Pagination,
            "button-top-bar":buttonsTopbar,
            // "filters-top-bar":FiltersTopbar,
            "Multiselect":Multiselect,
            CatalogMultiselectDropdownVue,
            "Datepicker":DatePicker,
            "cancel-icon":cancelIcon
        },
        methods:{
            removeSelectedCatalog(){
                this.$refs.catalogdropdownRef.searchKey = [];
                this.catalogSelectedDropDown = null;
                delete this.completeFormData['parent_catalog_id'];
                this.page = 1;
                this.refreshArchiveReport();
            },
            isFirstElement(option){
               console.log("isFirstElement",option);
               if(this.selectedMimeTypeValue[0].id == option.id){
                   return true;
               }
               return false;
            },
            downloadArchiveReportData() {
                let payload = {"job_name":"Generate Reports","element_type":"file","report_type":"archive_report"};
                if(this.completeFormData && Object.keys(this.completeFormData).length){
                    payload["query"] = {};
                    for(let key in this.completeFormData){
                        payload.query[key] = this.completeFormData[key];
                    }
                }
                if(this.fileNameFilter){
                  payload.query["slug_name"] = this.fileNameFilter;
                }
                this.$toast.info(this.$t("You will be notified once the report is ready to download"));
                this.createNewJob(payload).then(() => {
                })
                .catch(console.error);
            },
            updateFilenameSearchKey(){
                if(this.fileNameFilter){
                 this.completeFormData["slug_name"] = this.fileNameFilter;
                }else{
                    delete this.completeFormData["slug_name"];
                }
                this.page = 1;
                this.refreshArchiveReport();
            },
            handleCreatedDateChange(){
                if(this.time1[0]){
                  this.completeFormData['created_on'] = {type:"range",from_value:this.time1[0],to_value:this.time1[1]};
                }else{
                    delete this.completeFormData['created_on'];
                }
                this.page = 1;
                this.refreshArchiveReport();
            },
            handleCatalogRemove(catalog){
                console.log("handleCatalogRemove",catalog);
                delete this.completeFormData['parent_catalog_id'];
                this.catalogSelectedDropDown = null;
                this.page = 1;
                this.refreshArchiveReport();
            },
            handleCatalogSelection(catalog){
                    console.log("handleCatalogSelection handleCatalogSelection",catalog);
                    this.completeFormData['parent_catalog_id'] = catalog._id;
                    this.catalogSelectedDropDown = catalog;
                    this.page = 1;
                    this.refreshArchiveReport();
            },
            disabledDate(date) {
                const today = new Date();
                return date > today;
            },
            modifyTextFormat(text){
                if(text){
                    let temp = text.split("catalog://0/")[1];
                    if(temp){
                        temp = temp.replace("/","/")
                        return temp;
                    }
                }
            },
            searchArchivedAssetReport(){
                this.refreshArchiveReport();
            },
            makeMimeTypeFilterCheckboxAction(option){
                    return this.selectedMimeTypeValue.some((op) => op === option);
             },
             selectMimeTypeFilter(selectedOption,optionsArr){
                console.log("selectedOption",selectedOption,"optionsArr",optionsArr);
                let index = optionsArr.findIndex(item => item.id == selectedOption.id);
                if(index > -1){
                        optionsArr[index].checked = true;
                }
                setTimeout(() => {
                        this.completeFormData['mime_type'] = JSON.stringify(optionsArr.map(el => String(el.name).toLowerCase()));
                        this.page = 1;
                        this.refreshArchiveReport();
                }, 200);
            },
            removeSelectedMimeTypeFilterFromTag(selectedOption){
                this.selectedMimeTypeValue = this.selectedMimeTypeValue.filter(e => e.id != selectedOption.id);
                if(Array.isArray(this.selectedMimeTypeValue) && this.selectedMimeTypeValue.length){
                   this.completeFormData['mime_type'] = JSON.stringify(this.selectedMimeTypeValue.map(el => String(el.name).toLowerCase()));
                }else{
                    delete this.completeFormData['mime_type'];
                }
                this.page = 1;
                this.refreshArchiveReport();
            },
            changeSelectedReportComponent(filtersdata){
                this.payloadParams = filtersdata;
                this.refreshArchiveReport(false);
            },

            refreshArchiveReport(){
                let payload = {params:{}};
                if(this.page > 1){
                    payload.params['page'] = this.page;
                }
                if(this.completeFormData && Object.keys(this.completeFormData).length){
                    for(let key in this.completeFormData){
                        payload.params[key] = this.completeFormData[key];
                    }
                }
                if(this.fileNameFilter){
                  payload.params["slug_name"] = this.fileNameFilter;
                }
                this.getNewArchiveReport(payload).then((data) => {
                    if(data && Object.prototype.hasOwnProperty.call(data,'assets') && Array.isArray(data.assets) && data.assets.length){
                        this.totalPages = data["page_count"];
                        // this.page = data["page"];
                        this.totalArchiveFiles = data["total_assets"];
                        this.perPage = data["assets_per_page"];
                    }else{
                        this.totalPages = 0;
                        this.totalArchiveFiles = 0;
                        this.perPage = 0;
                    }
                    this.archiveReportData = data.assets;
                    this.$nextTick(()=>{
                        this.isDataLoaded = true;
                    });
                   
                }); 
                
            },

            paginate(page) {
                this.page = page;
                this.refreshArchiveReport(true);
            },

            getConvertedFileSize(size){
                return Utils.getConvertedFileSize(size);
            }, 

            ...mapActions("newArchiveReport", ["getNewArchiveReport"]),
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserPrivilege"]),
            ...mapGetters("pools",["getPoolsfromInMem"]),
            ...mapActions("jobs", ["createNewJob"]),
        },
        created(){
            this.refreshArchiveReport(false);
        },
    }
</script>            

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
$secondary-border-hover-color:#767676;

/* width */
::-webkit-scrollbar {
    width: 8px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }

    .text-ellipsis{
        white-space: nowrap; 
        width: 88%; 
        overflow: hidden;
        text-overflow: ellipsis; 
        display: block;
        // position: absolute;
    }
    .archive-report-div{
        padding: 0px 30px 10px 30px;
        height: calc(100% - 115px);
        overflow: auto;
    }

    .table-scroll thead th {
        position: sticky;
        top: 0;
        background: $primary-background;
        z-index: 9;
    }

    th, td{
        text-align: start;
    }

    tbody tr{
        border-bottom: $secondary-border-color;
    }
    table td, table th{
        vertical-align: top;
    }
    .activeclass {
        color: $active-blue;
    }
    .ccomm-logs-row:hover {
        .jobs-info-icon{
            visibility:visible;
        }
    }
    /*
    .ccomm-logs-row:hover{
        color: $active-blue;
    }*/
    .table-with-border {
        border-collapse: separate !important;
        border-spacing: 0px 12px !important;
        thead {
            border-bottom: none;
        }
        tr {
            border-bottom: none;
        }
    }
    
    .table{
        color:#fff !important;
        th{
            border-top:none !important;
            padding: 1rem !important;
        }
        td{
            border-top:none !important;
            padding: 0px !important;
            padding-inline-start: 2px !important;
        }

        .slug-common-label {
            font-size: 13px;
            width: 82px;
        }
        .locations,.containers{
            display: flex;
            width: 100%;
            flex-wrap: nowrap;
        }
        .locations .slug-common-label{
           width: 82px;
        }
    }
    .primary-btn-style{
        width: 100%;
        text-align: end;
        button{
            height: 38px;
            width: 70px;
            font-size:14px;
        }
        .text-light:hover{
        text-decoration: underline;
        }
    }
    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th{
                position: sticky;
                top: 0;
                background:$primary-background;
                z-index:9;
                padding: 0 !important;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr{
                height:60px !important;
                td{
                    span{
                        word-break: break-all;
                    }
                }
            }
        }
    }

    .search-bar-comm-style {
        input {
            border: $border-color;
            height: 42px !important;
            padding-inline-start: 12px;
        }
        svg {
            position: absolute;
            inset-inline-start:24px;
            top: 34%;
        }

        .slug-name-input {
            svg{
                inset-inline-end: 1px !important;
                inset-inline-start: unset !important;
            }
        }
    }

    .value-style {
        color: $text-color;
        width: 97%;
        text-align: start;
        padding-top: 3px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
    }

    .filter-fields-in-logs li{
         width: unset !important;
    }

    .filter-fields-in-logs div{
        display:inline-flex;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        div.comm-div{
            display:inline-flex;
            width:25%;
            // padding-top:7px;
            position: relative;
            // inset-inline-end :2%;
            label{
            color:$dull-text-color;
            position: relative;
            inset-inline-end: 5px;
            width:30%;
            text-align:end;
            top:2px;
            }
            select,input{
            width:70%;
            height:27px;
            border:$border-color;
            }

            input:hover{
                border : 1px solid $secondary-border-hover-color !important;
            }
        }
    }

    li {
      display: inline-flex;
      // margin-bottom: 20px;
    }

    .config-label {
        width: 26% !important;
        text-align: end;
        color: #757575;
        word-break: break-word;
        position: relative !important;
        top: 9px !important;
    }
    
    .config-value {
        margin-inline-start: 4px;
        width: 75% !important;
        display:grid;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }

    .apply-dull-text-color{
        color: #757575 !important;
    }

    .remove-catalog-value{
        svg{
           color: #757575 !important;
        }

        &:hover svg{
            background: #2c3339;
            fill: #eee;
            border-radius: 5px;
        }
    }

    ::v-deep {

        .catalogs-dropdown-wrapper-div{
            align-items: center;
            .save-cancel-icon.browse-icon{
                position: unset !important;
                width: unset !important;
                height: unset !important;
            }
        }

        .actions-button-wrapper .button.btn.btn-outline-secondary.m-2{
            margin: 0 !important;
        }

        .primary-btn-style.justify-content-end.download-button button {
            margin: 0 !important;
            height: 42px !important;
        }

         .mx-input{
            background-color:$primary-background !important;
            border: none !important;
            color: #eee !important;
            height:100%;
            padding: 10px 10px 10px 18px;
        }

        .mx-icon-calendar,.mx-icon-clear{
            color: $text-color !important;
        }

        .mx-datepicker:hover, mx-datepicker-range:hover{
            border:1px solid $secondary-border-hover-color !important;
        }

.asset-archive-wrapper{
    width: 87% !important;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    align-items: flex-start;
    grid-column-gap: 12px;
    grid-row-gap: 7px;

    .calendar-wrapper > div{
        width: 100% !important;
        height: 38px !important;
        border: 1px solid #4a4a4a;
    }

    .close-icon-searchbar{
        inset-inline-start: unset !important;
    }

.multiselect {
    width:100% !important;
    min-height: 38px !important;
    height: unset !important;
 }

 .common-slot-class.catalogs:hover{
    border: 1px solid $secondary-border-hover-color !important;
 }
 .mime-type-filter,.common-slot-class.catalogs{
  .multiselect {
    width:100% !important;
    color:$text-color;
  }
  .multiselect__tags-wrap{
    display: block !important;
  }
  .multiselect__content-wrapper {
    display: none;
  }
  .multiselect__tag, .selected-tags-style {
    background-color: $primary-background !important;
    border: $border-color;
    border-radius: 5px;
    margin-bottom: 5px;

  }
  .multiselect__tags, .selected-tags-style {
        background: $primary-background !important;
        border: $border-color !important;
  }
  
  .multiselect__option--highlight {
    background: $bg-color-on-hover !important;
  }
  .multiselect__content {
    background: $secondary-background-color !important;
  }
  .multiselect__input,
  .multiselect__single {
    background: transparent !important;
    color: $text-color;
    margin-bottom: 0 !important;
  }
  .multiselect__input:focus {
    outline: none;
    box-shadow: none;
  }
  .multiselect__tag-icon {
    color: $text-color !important;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $bg-color-on-hover !important;
    color: $text-color !important;
  }
  .multiselect__tag-icon:after {
    color: $secondary-text-color !important;
    font-size: 23px;
  }

  .multiselect__tag-icon {
    visibility: hidden;
  }

  .multiselect__tag:hover .multiselect__tag-icon {
    visibility: visible;
  }

  .multiselect * {
    font-size: $input-field-and-label-font-size !important;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .multiselect__placeholder {
    padding-top: 3px !important;
    margin-bottom:0px !important;
  }
  .multiselect {
    color: $text-color !important;
    font-size: $input-field-and-label-font-size !important;
  }
  .multiselect__single {
    padding-top: 3px;
  }
  .multiselect__option--selected {
    background: $bg-color-on-hover !important;
    color: $text-color;
  }
  .multiselect__content-wrapper {
    border: 1px solid $bg-color-on-hover !important;
    position: absolute;
    display: block;
    background: $text-color;
    width: 100%;
    overflow: auto;
    border: 1px solid $text-color;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
  }

  .multiselect__current,
  .multiselect__option {
    line-height: 12px !important;
  }

  .multiselect--above .multiselect__content-wrapper {
    background: $secondary-background-color !important;
  }
  .multiselect__tags {
    background: $primary-background !important;
    height: auto;
    padding: 8px 40px 8px 8px;
  }

  .remove-tag{
    color:$dull-text-color;
    line-height: 25px;
   }

   .remove-tag:hover{
        color:$text-color;
   }

   .selected-tags-style{
      display: inline-flex;
      padding-inline-start: 5px;
      margin-inline-end: 4px;
      margin-bottom: 5px;
      align-items: center;
   }

  }

  .mime-type-filter .multiselect__tags{
     border: none !important;
  }

    .multiselect:hover .multiselect__tags{
        border: 1px solid $secondary-border-hover-color !important;
    }

  }
 .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 5px !important;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 8px;
  }
  .VuePagination{
    position: fixed;
    bottom: 8px;
    inset-inline-end: 17px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 12px;
    margin-inline-end: 7px;
    margin-top: 1px;
    float: inline-end;
    position: relative;
    margin-inline-start: 5px;
    top: 5px;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    // width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display: none;
  }
  .VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination__pagination-item-next-page a:before {
   // width: 50px;
    content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after {
    // width: 50px;
    content: " prev";
  }
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }
  .v-menu__content {
    width: 190px !important;
  }

   .config-label{
      max-width: 128px;
      min-width: fit-content;
   }

   .multiselect__tags-wrap:has(> .selected-tags-style:first-child:last-child) > .selected-tags-style {
       margin-bottom: 0 !important;
    }

    // .mime-type-filter.common-slot-class .multiselect__tags{
    //     padding: 8px 40px 5px 8px !important;
    // }


    .common-slot-class.catalogs{
        border: 1px solid rgb(74, 74, 74);
        border-radius: 0.25rem !important;
        display: flex;
        align-items: center;
        .catalog-dropdown-wrapper{
            .catalog-main-select-dropdown{
                div.multiselect__tags{
                    border:  none !important;
                }
                .multiselect__single::before{
                    content: "Catalog : ";
                    color: $dull-text-color;
                    position: relative;
                }
            }
        }
    }

}    

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.new-archive-report-filters{
    display: flex;
    align-items: center !important;
}

.actions-button-wrapper{
    flex-wrap: unset !important;
    display: flex;
    align-items: flex-start !important;
    gap: 12px;
    flex: 1;
}

.selected-tags-style{
    display: inline-flex;
    padding-inline-start: 5px;
    margin-inline-end: 4px;
}

 .dull-the-text{
    color: $secondary-text-color;
  }

  .actions-button-wrapper{
    width: 100px;
    align-items: center;
    gap: 23px;
  }

  .change-the-text-color{
    color: #757575;
    text-transform: uppercase;
    // height: 22px;
    width: -moz-fit-content;
    width: fit-content;
    border: 1px solid #F49D1A;
    border-radius: 10px;
    padding: 3px 9px;
    color: #F49D1A;
    font-size: 10px;
    letter-spacing: 0.5px;
    max-width: 423px;
    overflow: hidden;
    white-space: nowrap !important;
    text-overflow: ellipsis;
    display: inline-block;
}



</style>